import { Router } from '@angular/router';
import { LoadingMaskService } from '../../base/services/loading-mask.service';
import { SystemMessageService } from '../../base/services/system-message.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private systemMessageService: SystemMessageService,
    private loadingMaskService: LoadingMaskService,
    private router: Router,
    private authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    console.log('HttpErrorInterceptor');

    console.log('HttpErrorInterceptor request.url = ' + request.url);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        console.log(error);
        let errorMsg = '';
        if (error.error instanceof ErrorEvent) {
          console.log('This is client side error');
          errorMsg = `Error: ${error.error.message}`;
        } else {
          console.log('This is server side error');
          // 如果是 AAD login 失敗就直接轉到錯誤頁面
          if (request.url.startsWith('/api/v1/auth/loginSso')) {
            this.router.navigate(['/error']);
          }

          switch (error.status) {
            case 400:
            case 401:
            case 403:
            case 405:
            case 500:
            case 502:
            case 503:
            case 504:
              errorMsg += `http-status.` + error.status;
              break;
            case 404:
              // 如果是手動登入的時候錯誤，改顯示訊息為帳號密碼錯誤
              if (request.url.startsWith('/api/v1/auth/login')) {
                errorMsg = 'message.detail.login-failed';
              } else {
                errorMsg += `http-status.` + error.status;
              }
              break;
            default:
              errorMsg += `http-status.error`;
              break;
          }
          // const stackTrace: string = error.error.stackTrace;
          // errorMsg = `Error Code: ${error.status} ${error.statusText} \n`;
          // if (stackTrace) {
          //   errorMsg += `StackTrace: ${stackTrace?.substring(0, 300)} ...`;
          // } else {
          //   errorMsg += `Error: ${error.message}`;
          // }
        }

        if (error.status === 401) {
          console.log('HttpErrorInterceptor this.authService.tokenError = ' + this.authService.tokenError);
          if (this.authService.tokenError) {
            this.systemMessageService.error(errorMsg, {
              'message': error.error?.message ?? ''
            });
          }
        } else {
          this.systemMessageService.error(errorMsg, {
            'message': error.error?.message ?? ''
          });
        }

        this.loadingMaskService.hide();
        console.log(errorMsg);
        return throwError(() => error);
      })
    );
  }
}
